// eslint-disable-next-line import/prefer-default-export
export enum QueryKeys {
  Me = 'me',
  RecruiterMe = 'recruiter-me',
  AgencyAvatar = 'agency-avatar',
  AgencyMe = 'agency-me',
  AgencyStatistic = 'agency-statistic',
  Invites = 'invites',
  MembersList = 'members-list',
  MembersCompactList = 'members-compact-list',
  ContractsList = 'contracts-list',
  ContractApplicationsList = 'contracts-applications-list',
  ContractApplicationsCount = 'contract-applications-count',
  JobCategories = 'job-categories',
  JobInfrastructures = 'job-infrastructures',
  JobSkills = 'job-skills',
  Applications = 'agency-applications',
  ApplicationsCount = 'agency-applications-count',
  ApplicationDetails = 'application-details',
  ContractorsList = 'contractors-list',
  ContractorDetails = 'contractor-details',
  ContractorsCount = 'contractors-count',
  AgenciesList = 'agencies-list',
  AgenciesDetails = 'agencies-details',
  AgenciesCount = 'agencies-count',
  FeedbackList = 'feedback-list',
  FeedbackDetails = 'feedback-details',
  FeedbackCount = 'feedback-count',
  SubscriptionWebTiers = 'subscription-web-tiers',
  SubscriptionMobileTiers = 'subscription-mobile-tiers',
  SubscriptionMyTiers = 'subscription-my-tiers',
  SubscriptionWebFeatures = 'subscription-web-features',
  SubscriptionMobileFeatures = 'subscription-mobile-features',
  Ads = 'ads',
  CoursesList = 'courses-list',
  CourseDetails = 'course-details',
  CourseCustomFields = 'course-custom-fields',
  CourseApplicationsList = 'course-applications-list',
  ListingTypes = 'listing-types',
}
